module.exports = {"body":"<p>A new or expanded mud room can take a cluttered messy entry, and convert it into a clean organized place for your family to transfer from outdoors to in.</p>\n<p>A mud room can be fitted with Custom lockers for coats and boots.\nDepending on the size, a mud room can often double as a laundry room.</p>\n<p>No matter your families needs, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Mudroom.md
// module id = 516
// module chunks = 0